var $4a6b836d4f1bfaba$exports = {};
$4a6b836d4f1bfaba$exports = {
    "alpha": `\u{C54C}\u{D30C}`,
    "blue": `\u{D30C}\u{B791}`,
    "brightness": `\u{BA85}\u{B3C4}`,
    "green": `\u{CD08}\u{B85D}`,
    "hue": `\u{C0C9}\u{C870}`,
    "lightness": `\u{BC1D}\u{AE30}`,
    "red": `\u{BE68}\u{AC15}`,
    "saturation": `\u{CC44}\u{B3C4}`
};


export {$4a6b836d4f1bfaba$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
